import React from 'react';
import SectionShape from '../../../components/SectionShape';

/**
 * Truth section (#truth).
 * Pure typographic beat — the "where vs what" contrast that expresses
 * the item-level purchase-data advantage. No images, no interactivity.
 *
 * data-rv="up" marks elements for the reveal-on-scroll observer (wired later).
 */
export default function Truth() {
  return (
    <section id="truth" style={{ position: 'relative', zIndex: 1 }}>
      <div
        style={{
          padding: 'clamp(96px,13vw,180px) clamp(20px,5vw,56px)',
          maxWidth: 'var(--max-width)',
          margin: '0 auto',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <SectionShape
          kind="ring"
          size={680}
          thickness={2}
          spin={false}
          opacity={0.9}
          position={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        />

        <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <h2
          data-rv="up"
          style={{
            margin: 0,
            fontSize: 'clamp(40px,5.4vw,78px)',
            fontWeight: 800,
            letterSpacing: '-0.025em',
            lineHeight: 1.12,
            maxWidth: '24ch',
            textWrap: 'balance',
          }}
        >
          <span style={{ color: 'var(--text-400)' }}>
            Your bank can tell you where you spent.
          </span>
          <br />
          <span style={{ color: 'var(--kachng-green)' }}>
            KACHNG can tell you
            <br />
            what you bought.
          </span>
        </h2>
        </div>

        <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>  
        <p
          data-rv="up"
          style={{
            margin: 'clamp(36px,4.5vw,56px) 0 0',
            fontSize: 'clamp(18px,1.8vw,23px)',
            lineHeight: 1.8,
            color: 'var(--text-muted)',
            maxWidth: '44ch',
          }}
        >
          Transactions remember the payment.
          <br />
          Receipts remember the purchase.
          <br />
          <span style={{ fontWeight: 600 }}>
            <span style={{ color: 'var(--kachng-green)' }}>KACHNG</span>{' '}
            <span style={{ color: 'var(--text)' }}>
              turns that purchase history into intelligence.
            </span>
          </span>
        </p>
        </div>
      </div>
    </section>
  );
}